import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Head from "next/head";
import { renderMetaTags } from "react-datocms";
import dynamic from "next/dynamic";

// Import required components
const Header = dynamic(() => import("@/common/Header"));
const Footer = dynamic(() => import("@/common/Footer"));

const Master = (props) => {
  const { labelsConfigData } = props;

  const [labelsList, setLabelsList] = useState({});
  const [siteConfig, setSiteConfig] = useState({});
  const [settingsData, setSettingData] = useState();

  useEffect(() => {
    setLabelsList(labelsConfigData?.labelsAndConfigData?.labelsList);
    setSiteConfig(labelsConfigData?.labelsAndConfigData?.siteConfig);
    setSettingData(labelsConfigData?.labelsAndConfigData?._site);
  }, [labelsConfigData]);

  return (
    <>
      {settingsData && <Head>{renderMetaTags(settingsData?.favicon)}</Head>}

      {!labelsConfigData?.isLoading && (
        <Header
          labelsList={labelsList}
          siteConfig={siteConfig}
          settingsData={settingsData}
          menuList={labelsConfigData?.labelsAndConfigData}
        />
      )}

      <main className="main">{props?.children}</main>

      {!labelsConfigData?.isLoading && (
        <Footer
          labelsList={labelsList}
          siteConfig={siteConfig}
          menuList={labelsConfigData?.labelsAndConfigData}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  labelsConfigData: state.labelsConfig,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Master);
